import {specOrder, SPEC_MAPPER} from './constant.js'
import {Message} from 'element-ui';

function getCategoryName(cat){
      switch(cat){
        case 'Nature':
          return '自然';
        case 'Objects':
          return '物体';
        case 'People':
          return '表情';
        case 'Places':
          return '位置';
        case 'Symbols':
          return '符号';
      }
}
function showProductName(p) {
  let name = p.name_cn || p.name;
  if (p.brand_prefix_cn){
    if(name.toLowerCase().indexOf(p.brand_prefix_cn.toLowerCase()) == 0){
      let reg = new RegExp(p.brand_prefix_cn,'i')
      return name.replace(reg,p.brand_prefix_cn)
    }
    else
      return p.brand_prefix_cn + ' ' + name
  }
  else
    return name
}

function sizeUnit(size, unit) {
  let arr = []
  if (!unit || unit.toLowerCase() == 'size')
    return size
  if (unit.indexOf(':') > -1) {
    if (unit.indexOf(':M') > -1 || unit.indexOf(':W') > -1)
      return unit + size
    else if (unit.indexOf(':U') > -1)
      return unit.replace(':U', ":" + size)
    else if (unit.indexOf(':Y') > -1 || unit.indexOf(':K') > -1) {
      arr = unit.split(':')
      return arr[0] + ":" + size + arr[1]
    }
  } else {
    return unit + ':' + size
  }
}

function formatSpec(spec, line) {
  if (line)
    line.isHideSpecLabel = false
  let specStr = ''
  try {
    if (typeof spec !== "object") {
      spec = spec.replace(/\n/g, '')
      spec = JSON.parse(spec)
    }
    if (spec.spec) {
      //如果是手动填写规格，则直接使用
      return spec.spec.replace(/\n/g, '');
    } else {
      if (line)
        line.isHideSpecLabel = true;
      let orderspec = {}
      //对主规格重现排序提到最前
      let specOrder_order = []
      if (line.unique_param) {
        specOrder_order.push(line.unique_param.replace('_list', ''))
        specOrder.forEach((i) => {
          if (i != line.unique_param.replace('_list', ''))
            specOrder_order.push(i)
        })
      } else
        specOrder_order = specOrder
      specOrder_order.forEach((i) => {
        if (spec.hasOwnProperty(i))
          orderspec[i] = spec[i]
      })
      let i = 0;
      for (let item in orderspec) {
        if (spec[item] && item !== 'merchant') {
          if (specStr !== '') {
              //specStr += '<br /> '
            if (i <= 1)
              specStr += ' <span style="font-weight:bold;color:black;">·</span> '
            else
              specStr += ' '
          }
          let s = spec[item]
          if (item == 'size') {
            s = sizeUnit(s, line.size_unit)
          }
          specStr = specStr + s
          //specStr = specStr + SPEC_MAPPER[item] + '：' + s
          i++
        }
      }
    }
  } catch (error) {
    console.log('error', error)
    specStr = spec
  }
  return specStr.replace('#','-')
}

function formatSpecNoLoopUpdate(spec, line) {
  let specStr = ''
  try {
    spec = spec.replace(/\n/g, '')
    spec = JSON.parse(spec)
    if (spec.spec) {
      //如果是手动填写规格，则直接使用
      return spec.spec.replace(/\n/g, '');
    } else {
      let orderspec = {}
      //对主规格重现排序提到最前
      let specOrder_order = []
      if (line.unique_param) {
        specOrder_order.push(line.unique_param.replace('_list', ''))
        specOrder.forEach((i) => {
          if (i != line.unique_param.replace('_list', ''))
            specOrder_order.push(i)
        })
      } else
        specOrder_order = specOrder
      specOrder_order.forEach((i) => {
        if (spec.hasOwnProperty(i))
          orderspec[i] = spec[i]
      })
      let i = 0;
      for (let item in orderspec) {
        if (spec[item] && item !== 'merchant') {
          if (specStr !== '') {
            if (i <= 1)
              specStr += '<br /> '
            else
              specStr += ' '
          }
          let s = spec[item]
          if (item == 'size') {
            s = sizeUnit(s, line.size_unit)
          }
          specStr = specStr + SPEC_MAPPER[item] + '：' + s
          i++
        }
      }
    }
  } catch (error) {
    console.log('error', error)
    specStr = spec
  }
  return specStr
}

function copy(value) {
  let oInput = document.createElement('input')
  oInput.value = value
  document.body.appendChild(oInput)
  oInput.select() // 选择对象
  document.execCommand("Copy") // 执行浏览器复制命令
  Message.success('复制成功')
  oInput.remove()
}
function reducePrice(arr) {
  if(!arr||!arr.length){
    return 0;
  }
  if(arr.length==1){
    return isNaN(arr[0])?'0':arr[0];
  }
 let result= arr.reduce((total,number)=>{
    if(isNaN(total)){
      total=0.00;
    }
    if(isNaN(number)){
      number=0.00
    }
    return total+number
  })
  return Number(result).toFixed(2);
}
function handleStyle(index) {
  let data = {position: 'absolute', top: '0px', left: '0',
    'text-align':'center',
    'transform': 'translate(-50%, -50%)',
    'clip-path': 'polygon(50% 0%, 62% 38%, 100% 38%, 70% 59%, 84% 100%, 50% 77%, 16% 100%, 30% 59%, 0% 38%, 38% 38%)'
};
  if (index == 1 || index == 2) {
    data.background = '#ffffff'
  } else if (index == 3 || index == 4) {
    data.background = '#ffeca1'
  } else if (index == 5) {
    data.background = '#ffde59'
  } else {
    data.background = '#ff8285'
  }
  return data;
};

const chineseNames = {
  // ==================== People & Emotions ====================
  'grinning': '咧嘴笑',
  'grin': '露齿笑',
  'joy': '喜极而泣',
  'rofl': '笑翻',
  'smiley': '开心笑',
  'smile': '微笑',
  'sweat_smile': '哭笑不得',
  'laughing': '大笑',
  'innocent': '天使',
  'wink': '眨眼',
  'blush': '害羞',
  'slightly_smiling_face': '微微笑',
  'upside_down_face': '倒笑脸',
  'yum': '好吃',
  'relieved': '松了口气',
  'heart_eyes': '爱心眼',
  'kissing_heart': '飞吻',
  'kissing': '亲吻',
  'kissing_smiling_eyes': '含笑亲吻',
  'kissing_closed_eyes': '闭眼亲吻',
  'stuck_out_tongue_winking_eye': '吐舌眨眼',
  'stuck_out_tongue_closed_eyes': '吐舌闭眼',
  'stuck_out_tongue': '吐舌头',
  'money_mouth_face': '金钱嘴',
  'hugs': '拥抱',
  'nerd_face': '书呆子',
  'sunglasses': '墨镜',
  'clown_face': '小丑',
  'cowboy_hat_face': '牛仔',
  'smirk': '得意',
  'unamused': '不爽',
  'disappointed': '失望',
  'pensive': '沉思',
  'worried': '担心',
  'angry': '生气',
  'rage': '愤怒',
  'triumph': '胜利',
  'cry': '大哭',
  'sob': '嚎啕大哭',
  'frowning': '皱眉',
  'persevere': '坚持',
  'disappointed_relieved': '失望但释然',
  'open_mouth': '吃惊',
  'hushed': '安静',
  'cold_sweat': '冷汗',
  'scream': '尖叫',
  'astonished': '震惊',
  'flushed': '脸红',
  'sleeping': '睡觉',
  'drooling_face': '流口水',
  'dizzy_face': '头晕',
  'face_with_thermometer': '发烧',
  'face_with_head_bandage': '受伤',
  'nauseated_face': '恶心',
  'sneezing_face': '打喷嚏',
  'mask': '口罩',
  'face_with_rolling_eyes': '翻白眼',
  'thinking': '思考',
  'lying_face': '说谎',
  'neutral_face': '面无表情',
  'expressionless': '毫无表情',
  'no_mouth': '没嘴',
  'grimacing': '做鬼脸',
  'rolling_eyes': '翻白眼',
  'smiling_imp': '笑脸恶魔',
  'imp': '小恶魔',
  'skull': '骷髅',
  'skull_and_crossbones': '骷髅头',
  'ghost': '幽灵',
  'alien': '外星人',
  'space_invader': '太空侵略者',
  'robot': '机器人',
  'poop': '便便',
  
  // ==================== Heart & Emotion Symbols ====================
  'heart': '爱心',
  'yellow_heart': '黄心',
  'green_heart': '绿心',
  'blue_heart': '蓝心',
  'purple_heart': '紫心',
  'black_heart': '黑心',
  'broken_heart': '心碎',
  'heart_exclamation': '心形感叹号',
  'two_hearts': '双爱心',
  'revolving_hearts': '旋转爱心',
  'heartbeat': '心跳',
  'heartpulse': '心跳动',
  'sparkling_heart': '闪亮爱心',
  'cupid': '爱神之箭',
  'gift_heart': '礼物爱心',
  'heart_decoration': '爱心装饰',
  'kiss': '亲吻',
  'zzz': '睡觉',
  'anger': '生气符号',
  'bomb': '炸弹',
  'boom': '爆炸',
  'sweat_drops': '汗滴',
  'dash': '冲刺',
  'speech_balloon': '对话框',
  'thought_balloon': '思考框',
  'hole': '洞',
  
  // ==================== People & Gestures ====================
  'wave': '挥手',
  'raised_back_of_hand': '手背',
  'raised_hand_with_fingers_splayed': '张开手掌',
  'hand': '手',
  'spock-hand': '瓦肯手势',
  'ok_hand': '没问题',
  'v': '胜利',
  'crossed_fingers': '交叉手指',
  'metal': '摇滚手势',
  'call_me_hand': '打电话手势',
  'point_left': '向左指',
  'point_right': '向右指',
  'point_up_2': '向上指',
  'point_up': '向上指',
  'middle_finger': '中指',
  'thumbsup': '点赞',
  'thumbsdown': '踩',
  'fist': '拳头',
  'punch': '出拳',
  'clap': '鼓掌',
  'raised_hands': '举手欢呼',
  'open_hands': '张开双手',
  'pray': '祈祷',
  'muscle': '肌肉',
  'selfie': '自拍',
  'princess': '公主',
  'prince': '王子',
  'man_with_turban': '戴头巾的人',
  'man_with_gua_pi_mao': '瓜皮帽男',
  'person_with_headscarf': '戴头巾',
  'person_in_tuxedo': '穿礼服',
  'bride_with_veil': '新娘',
  'pregnant_woman': '孕妇',
  'baby': '婴儿',
  'angel': '天使',
  'santa': '圣诞老人',
  'mrs_claus': '圣诞奶奶',
  'person_frowning': '皱眉的人',
  'person_with_pouting_face': '撅嘴的人',
  'no_good': '不行',
  'ok_woman': 'OK',
  'information_desk_person': '咨询台',
  'raising_hand': '举手',
  'bow': '鞠躬',
  'face_palm': '捂脸',
  'shrug': '耸肩',
  
  // ==================== Animals & Nature ====================
  'dog': '狗',
  'cat': '猫',
  'mouse': '老鼠',
  'hamster': '仓鼠',
  'rabbit': '兔子',
  'fox_face': '狐狸',
  'bear': '熊',
  'panda_face': '熊猫',
  'koala': '考拉',
  'tiger': '老虎',
  'lion_face': '狮子',
  'cow': '牛',
  'pig': '猪',
  'frog': '青蛙',
  'monkey_face': '猴子',
  'monkey': '猴子',
  'chicken': '鸡',
  'penguin': '企鹅',
  'bird': '鸟',
  'baby_chick': '小鸡',
  'hatching_chick': '破壳小鸡',
  'snake': '蛇',
  'turtle': '乌龟',
  'dragon': '龙',
  'unicorn': '独角兽',
  'horse': '马',
  'elephant': '大象',
  'octopus': '章鱼',
  'snail': '蜗牛',
  'butterfly': '蝴蝶',
  'bee': '蜜蜂',
  'ant': '蚂蚁',
  'ladybug': '瓢虫',
  'fish': '鱼',
  'tropical_fish': '热带鱼',
  'dolphin': '海豚',
  'whale': '鲸鱼',
  'rose': '玫瑰',
  'tulip': '郁金香',
  'sunflower': '向日葵',
  'blossom': '花',
  'cherry_blossom': '樱花',
  'sun': '太阳',
  'moon': '月亮',
  'star': '星星',
  'cloud': '云',
  'umbrella': '雨伞',
  'snowflake': '雪花',
  'fire': '火',
  
  // ==================== Food & Drink ====================
  'apple': '苹果',
  'green_apple': '青苹果',
  'pear': '梨',
  'tangerine': '橘子',
  'lemon': '柠檬',
  'banana': '香蕉',
  'watermelon': '西瓜',
  'grapes': '葡萄',
  'strawberry': '草莓',
  'melon': '蜜瓜',
  'cherries': '樱桃',
  'peach': '桃子',
  'pineapple': '菠萝',
  'tomato': '番茄',
  'eggplant': '茄子',
  'avocado': '牛油果',
  'pizza': '披萨',
  'hamburger': '汉堡',
  'fries': '薯条',
  'hotdog': '热狗',
  'taco': '墨西哥卷',
  'burrito': '卷饼',
  'sandwich': '三明治',
  'rice': '米饭',
  'curry': '咖喱',
  'ramen': '拉面',
  'spaghetti': '意面',
  'sushi': '寿司',
  'cake': '蛋糕',
  'birthday': '生日蛋糕',
  'chocolate_bar': '巧克力',
  'candy': '糖果',
  'cookie': '饼干',
  'ice_cream': '冰淇淋',
  'coffee': '咖啡',
  'tea': '茶',
  'beer': '啤酒',
  'wine_glass': '红酒',
  'cocktail': '鸡尾酒',
  
  // ==================== Activities & Sports ====================
  'soccer': '足球',
  'basketball': '篮球',
  'football': '美式足球',
  'baseball': '棒球',
  'tennis': '网球',
  'volleyball': '排球',
  'golf': '高尔夫',
  'ping_pong': '乒乓球',
  'trophy': '奖杯',
  'medal': '奖牌',
  'musical_note': '音符',
  'microphone': '麦克风',
  'headphones': '耳机',
  'guitar': '吉他',
  'trumpet': '小号',
  'violin': '小提琴',
  'drum': '鼓',
  
  // ==================== Travel & Places ====================
  'car': '汽车',
  'taxi': '出租车',
  'bus': '公交车',
  'truck': '卡车',
  'bicycle': '自行车',
  'motorcycle': '摩托车',
  'airplane': '飞机',
  'rocket': '火箭',
  'train': '火车',
  'subway': '地铁',
  'ship': '船',
  'house': '房子',
  'office': '办公室',
  'hospital': '医院',
  'school': '学校',
  'hotel': '酒店',
  
  // ==================== Objects ====================
  'iphone': '手机',
  'computer': '电脑',
  'tv': '电视',
  'camera': '相机',
  'video_camera': '摄像机',
  'book': '书',
  'newspaper': '报纸',
  'pencil': '铅笔',
  'pen': '钢笔',
  'scissors': '剪刀',
  'umbrella': '雨伞',
  'watch': '手表',
  'ring': '戒指',
  'gift': '礼物',
  'balloon': '气球',
  'ribbon': '丝带',
  
  // ==================== Symbols ====================
  '100': '满分',
  '1234': '数字',
  'cool': '酷',
  'free': '免费',
  'new': '新',
  'ok': 'OK',
  'up': '向上',
  'vs': '对战',
  'atm': 'ATM',
  'cn': '中国',
  'us': '美国',
  'jp': '日本',
  'kr': '韩国',
  'fr': '法国',
  'de': '德国',
  'it': '意大利',
  'uk': '英国',
  'ru': '俄罗斯',
  'checkered_flag': '方格旗'
}

export {
  handleStyle,
  chineseNames,
  copy,
  showProductName,
  getCategoryName,
  sizeUnit,
  formatSpec,
  formatSpecNoLoopUpdate,
  reducePrice
}



// WEBPACK FOOTER //
// ./src/services/tools.js